import React, { Component } from 'react';
import svgSubmitted from '../../assets/svg/confirm_fig.svg';
import './Submitted.less'

class Submitted extends Component {

  handleBackHome() {
  const homePage = process.env.BUILD_TEST
      ? '//xs.t.shijieu.cn/xstatic/xbag/college/subjectchoice/welcome'
      : '//xs.shijieu.cn/xstatic/xbag/college/subjectchoice/welcome'
    window.location.assign(homePage)
  }

  render() {
    return (
      <div className="subject-choice-wrapper">
        <div className="subject-choice-inner choice-submitted">
          <p className="submitted-title">选科意向提交成功</p>
          <img className="submitted-img" src={svgSubmitted} alt="确认" />
        </div>
        <div className="subject-choice-bottom two-choice">
          <button className="full" onClick={this.handleBackHome.bind(this)}>返回结果页</button>
        </div>
      </div>
    );
  }
}

export default Submitted;



// WEBPACK FOOTER //
// ./src/pages/SubjectChoice/Submitted.js